// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"a7113c40","703":"b9577f49"}[chunkId] + ".chunk.js";
};